import { NgModule } from '@angular/core';
import { IconModule } from '@nibtravel/shared/ui/components/icon';

import { alertIcon } from './icons/alert';
import { amexIcon } from './icons/amex';
import { arrowIcon } from './icons/arrow';
import { chevronIcon } from './icons/chevron';
import { closeIcon } from './icons/close';
import { discountIcon } from './icons/discount';
import { discountAltIcon } from './icons/discount-alt';
import { documentIcon } from './icons/document';
import { editIcon } from './icons/edit';
import { infoIcon } from './icons/info';
import { jcbIcon } from './icons/jcb';
import { maestroIcon } from './icons/maestro';
import { mailIcon } from './icons/mail';
import { mastercardIcon } from './icons/mastercard';
import { minusIcon } from './icons/minus';
import { nibPoweredIcon } from './icons/nibPowered';
import { percentageIcon } from './icons/percentage';
import { phoneIcon } from './icons/phone';
import { plusIcon } from './icons/plus';
import { successIcon } from './icons/success';
import { tickIcon } from './icons/tick';
import { trashIcon } from './icons/trash';
import { visaIcon } from './icons/visa';
import { warningIcon } from './icons/warning';

@NgModule({
  imports: [
    IconModule.forRoot({
      icons: [
        alertIcon,
        amexIcon,
        arrowIcon,
        chevronIcon,
        closeIcon,
        discountAltIcon,
        discountIcon,
        documentIcon,
        editIcon,
        infoIcon,
        jcbIcon,
        maestroIcon,
        mailIcon,
        mastercardIcon,
        minusIcon,
        nibPoweredIcon,
        percentageIcon,
        phoneIcon,
        plusIcon,
        successIcon,
        tickIcon,
        trashIcon,
        visaIcon,
        warningIcon,
      ],
    }),
  ],
})
export class IconsModule {}
